import { MouseEvent, PropsWithChildren, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { getElementForPortal } from '../../helpers';
import * as S from './styled';

interface ModalProps {
	title?: string,
	onClose?: () => void
}

const Modal = (props: PropsWithChildren<ModalProps>) => {
	const [isOpen, setIsOpen] = useState<boolean>(true);

	function handleClose(e: MouseEvent) {
		e.preventDefault();

		setIsOpen(false);
		props.onClose?.();
	}

	if ( ! isOpen ) {
		return null;
	}

	return ReactDOM.createPortal(
		<S.Main>
			<S.Container>
				<S.Inner>
					<S.CloseButton onClick={handleClose}>X</S.CloseButton>
					{props.title && <S.Title>{props.title}</S.Title>}

					{props.children}
				</S.Inner>
			</S.Container>
		</S.Main>
	, getElementForPortal())
};

export default Modal;
